import React, { useEffect, useRef, useState } from "react"
import AppToaster from "utils/AppToaster"
import formatAddress from "utils/googleMaps"
import PinMarker from "../../Molecules/PinMarker"
import Map from "./Map"
function LocationMap({ center, onChange, disabled, children }) {
  const mapRef = useRef(null)
  const [position, setPosition] = useState(center)

  useEffect(() => {
    setPosition(center)
  }, [center])

  function handleLoad(map) {
    mapRef.current = map
  }

  function handleZoomChanged() {
    if (!mapRef.current) return
    mapRef.current.panTo(position)
  }

  function handleDrag() {
    if (disabled) return
    if (!mapRef.current) return
    const newPos = mapRef.current.getCenter().toJSON()
    setPosition(newPos)
  }

  function handleDragEnd() {
    if (disabled) return
    const newPos = mapRef.current.getCenter().toJSON()
    const geocoder = new window.google.maps.Geocoder()
    geocoder.geocode({ location: newPos }, (result, status) => {
      if (status !== "OK") {
        AppToaster.show({
          message: "Unable to load the map results",
          intent: "warning",
        })
      } else {
        const addressComponent = result[0].address_components
        const addressString = result[0]?.formatted_address
        const address = formatAddress(addressComponent)
        // Set the co-ordinates to the current map center
        onChange && onChange(newPos, { ...address, address: addressString })
      }
    })
  }

  return (
    <Map
      onLoad={handleLoad}
      onDrag={handleDrag}
      onDragEnd={handleDragEnd}
      zoom={15}
      center={center}
      id="map"
      onZoomChanged={handleZoomChanged}
      mapContainerStyle={{
        width: " 100%",
        height: 500,
      }}
    >
      {position.lat && position?.lng && (
        <PinMarker latitude={position?.lat} longitude={position?.lng} />
      )}
      {children}
    </Map>
  )
}

export default LocationMap
